import { StateCreator } from 'zustand';
import { allSlices, whiteboard } from './interface';

const createWhiteboardSlice: StateCreator<allSlices, [], [], whiteboard> = (set) => ({
  video: false,
  videoError: false,
  toggleVideo: (video: boolean) =>
    set((state) => ({
      whiteboard: {
        ...state.whiteboard,
        video: video
      }
    })),
  setVideoError: (hasError: boolean) =>
    set((state) => ({
      whiteboard: {
        ...state.whiteboard,
        videoError: hasError
      }
    }))
});

export default createWhiteboardSlice;
